"use strict";

var _interopRequireDefault = require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.number.constructor");

var _vueCountTo = _interopRequireDefault(require("vue-count-to"));

var _BarChart = _interopRequireDefault(require("../components/BarChart"));

var _CardInfoV = _interopRequireDefault(require("@/views/dashboard/components/CardInfo/Agent/CardInfoV0"));

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  name: "agent-v0",
  props: {
    profile: Object,
    user: Object,
    labels: Array,
    values: Array,
    loadingUser: Boolean,
    loadingProfile: Boolean,
    numberOfDecimal: Number
  },
  components: {
    CountTo: _vueCountTo.default,
    BarChart: _BarChart.default,
    CardInfo: _CardInfoV.default
  },
  computed: {
    cardInfo: function cardInfo() {
      if (Object.keys(this.profile).length === 0) return;
      return [[{
        top: {
          label: this.$t('dashboard.agent.availableQuota'),
          // value: parseFloat(this.profile.orgAmount.quotaAmount)
          value: parseFloat(this.user.processAvailableAmount)
        },
        bottom: {
          label: this.$t('dashboard.agent.rechargeTotal'),
          value: parseFloat(this.user.processAmount) // value: parseFloat(this.profile.orgAmount.amount),

        },
        // unit: this.$store.getters.dollarSign,
        decimal: true,
        numberOfDecimal: this.numberOfDecimal,
        icon: 'form',
        color: '#36a3f7',
        text: this.$t('dashboard.agent.overall')
      }, {
        top: {
          label: this.$t('dashboard.agent.uncreditedAmount'),
          value: parseFloat(this.user.processUncreditedAmount)
        },
        bottom: {
          label: this.$t('dashboard.agent.frozenAmount'),
          value: parseFloat(this.user.processFrozenAmount)
        },
        // unit: this.$store.getters.dollarSign,
        decimal: true,
        numberOfDecimal: this.numberOfDecimal,
        icon: 'star',
        color: '#ffb900',
        text: this.$t('dashboard.agent.overall')
      }], [{
        top: {
          label: this.$t('dashboard.agent.queryAPIToday'),
          value: this.profile.organizationQueryApiCountToday // value: 0

        },
        bottom: {
          label: this.$t('dashboard.agent.paySuccessToday'),
          value: this.profile.organizationRechargeCountToday // value: 0

        },
        // unit: this.$t('dashboard.agent.smsUnit'),
        numberOfDecimal: this.numberOfDecimal,
        decimal: false,
        icon: 'email',
        color: '#f4516c',
        text: this.$t('dashboard.agent.today')
      }, {
        top: {
          label: this.$t('dashboard.agent.profit'),
          value: parseFloat(this.profile.agentProfitToday) // value: parseFloat(0)

        },
        bottom: {
          label: this.$t('dashboard.agent.cost'),
          value: parseFloat(this.profile.organizationRechargeAmountToday) // value: parseFloat(0),

        },
        // unit: this.$store.getters.dollarSign,
        numberOfDecimal: this.numberOfDecimal,
        decimal: true,
        icon: 'money',
        color: '#34bfa3',
        text: this.$t('dashboard.agent.today')
      }]];
    }
  }
};
exports.default = _default;